import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo-medium.png"

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'gpon';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert: parameters.cp_convert
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="gponFormContainer" ref={nodeRef}>
        <img alt="gpon-logo" src={logo} className="gpon-logo-medium" />
        <Form onSubmit={(event) => onSubmit(event)} className="gponLoginForm">
          <div className="gponLoginForm_msgContainer">
            <p className="gponLoginForm_loginMessage">{translate("ClientAuthentication")}</p>
          </div>
          <div className="gponForm">
            <input
              className="gpon-input"
              disabled={onLogin}
              onChange={e => setUsername(e.target.value)}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="login"
              id="login"
              placeholder={translate("PlaceholderUserName")}
            />
            <input
              className="gpon-input"
              required={true}
              disabled={onLogin}
              onChange={e => setPassword(e.target.value)}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
              name="login"
              placeholder={translate("PlaceholderPassword")}
            />
            <div className="redirectUrl-container">
              <a href="https://gpon.pe/" className="redirectUrl-container_url">{translate("ForgotPassword")}</a>
            </div>
            <>
              {!onLogin ? (
                <button type="submit" className="submitButton" id="entrar" disabled={!props.turnstileSuccess} >
                  <span className="submit" id="text">
                    {translate("ButtonEnter")}
                  </span>
                </button>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
            </>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </div>
        </Form>
        <p className="footer">{translate("Footer")}</p>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
